import * as Yup from 'yup';

export const signUpFinalStepSchema = Yup.object({
  referedBy: Yup.string().required('Provide Referrer Information'),
  hasClaims: Yup.string().required('Please select whether you have claims'),
  totalClaims: Yup.string().when('hasClaims', {
    is: 'yes',
    then: (schema) => schema.required('Please enter number of claims'),
  }),
});
